import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "minus",
  "use": "minus-usage",
  "viewBox": "0 0 500 500",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 500 500\" id=\"minus\">\n  <path fill=\"currentColor\" d=\"M110.831242,58.1094014 C87.5381197,34.251956 51.3411417,70.5182339 74.6240342,94.3653118 C105.443858,125.923432 254.719856,308.034691 288.977474,342.081578 C312.608406,365.569779 348.836446,329.334481 325.184806,305.825668 C292.250362,273.093324 142.891726,90.9405212 110.831242,58.1094014 Z\" transform=\"rotate(131 214.905 232.432)\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol